import React from 'react';
import { formatChatDate, truncate } from './chat-utils';

/**
 * Display list of previous chat sessions
 */
export function HistoryView({ sessions, onSelectSession, onDeleteSession, loading }) {
  if (loading) {
    return <div className="chat-history-empty">Loading conversations…</div>;
  }

  if (!sessions || sessions.length === 0) {
    return <div className="chat-history-empty">No conversations yet</div>;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      {sessions.map(session => (
        <div
          key={session.id}
          className="chat-history-item"
          onClick={() => onSelectSession?.(session.id)}
        >
          <div className="chat-history-title">{truncate(session.title, 60)}</div>
          <div className="chat-history-meta">
            {session.message_count || 0} messages · {formatChatDate(session.updated_at)}
          </div>
          <button
            className="chat-history-delete"
            onClick={(e) => {
              e.stopPropagation();
              if (window.confirm('Delete this conversation?')) {
                onDeleteSession?.(session.id);
              }
            }}
          >
            Delete
          </button>
        </div>
      ))}
    </div>
  );
}
